import { openDB } from "./indexedDb";
import api from "../components/api";

export async function saveDoctorConsultationOffline(data) {
  console.log("💾 Saving doctor consultation offline", data.patient_excel_id);

  const db = await openDB();

  return new Promise((resolve, reject) => {
    const tx = db.transaction("doctor_consultation", "readwrite");
    const store = tx.objectStore("doctor_consultation");

    store.add({
      ...data,
      synced: 0,
      created_at: new Date().toISOString()
    });

    tx.oncomplete = resolve;
    tx.onerror = () => reject(tx.error);
  });
}

export async function syncDoctorConsultations() {
  const db = await openDB();

  const records = await new Promise((resolve, reject) => {
    const tx = db.transaction("doctor_consultation", "readonly");
    const store = tx.objectStore("doctor_consultation");
    const index = store.index("synced");
    const request = index.getAll(0);

    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });

  for (let record of records) {
    try {
      const { synced, created_at, id, ...cleanData } = record;

      // 🔥 Post consultation
      await api.post('/technician/doctor-consultation/', cleanData);

      // 🔥 Mark service complete
      await api.post('/technician/submit/', {
        excel_patient_id: record.patient_excel_id,
        technician_id: record.technician_id,
        service_id: record.service_id
      });

      // 🔥 Mark as synced
      await new Promise((resolve, reject) => {
        const tx = db.transaction("doctor_consultation", "readwrite");
        const store = tx.objectStore("doctor_consultation");

        store.put({ ...record, synced: 1 });

        tx.oncomplete = resolve;
        tx.onerror = () => reject(tx.error);
      });

      console.log("✅ Synced consultation:", record.patient_excel_id);

    } catch (err) {
      console.error("❌ Sync failed:", err);
    }
  }
}

export async function getDoctorConsultationSyncStats() {
  const db = await openDB();

  return new Promise((resolve, reject) => {
    const tx = db.transaction("doctor_consultation", "readonly");
    const store = tx.objectStore("doctor_consultation");
    const index = store.index("synced");

    const unsyncedRequest = index.getAll(0);
    const syncedRequest = index.getAll(1);

    let unsynced = 0;
    let synced = 0;

    unsyncedRequest.onsuccess = () => {
      unsynced = unsyncedRequest.result.length;

      syncedRequest.onsuccess = () => {
        synced = syncedRequest.result.length;

        resolve({
          synced,
          unsynced,
          total: synced + unsynced
        });
      };
    };

    unsyncedRequest.onerror = reject;
    syncedRequest.onerror = reject;
  });
}